// Admin users list + detail queries (server-side pagination).
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useIsPlatformAdmin } from '../../../shared/scope/useCurrentScope.js';

import {
  getAdminUserById,
  getAdminUserDetailQueryKey,
  getAdminUsersQueryKey,
  listAdminUsers,
  type AdminUsersFilters,
} from '../api/admin.client.js';

export function useAdminUsers(filters: AdminUsersFilters) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminUsersQueryKey(filters),
    queryFn: () => listAdminUsers(filters),
    enabled: isPlatformAdmin,
    // Page/filter changes keep the previous rows visible instead of flashing
    // a skeleton — same contract as the tenant DataView screens.
    placeholderData: keepPreviousData,
  });
}

export function useAdminUserDetail(userId: string | null) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminUserDetailQueryKey(userId ?? 'none'),
    queryFn: () => getAdminUserById(userId ?? ''),
    enabled: isPlatformAdmin && userId !== null,
  });
}
